var icon = require('vue-svgicon')
icon.register({
  'ks-icon-upgrade': {
    width: 128,
    height: 128,
    viewBox: '0 0 128 128',
    data: '<path pid="0" d="M64.41 22L29.82 56.59h19.77v29.64h29.64V56.59H99L64.41 22zM49.59 96.12h29.65V106H49.59z"/>'
  }
})
